<template lang='pug' src='./about-us.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Hero from 'components/Hero/Hero'
import HeadBar from 'components/block/block-text-header/block-text-header'
import HeadMainBar from 'components/block/block-text-main-header/block-text-main-header'
import TextBox from 'components/block/block-text-box/block-text-box'
import Slider from 'components/custom/custom-slider-multitool/custom-slider-multitool'
import CustomSlider from 'components/custom/custom-new-slider/custom-new-slider'
import SliderStaff from 'components/custom/custom-slider-staff/custom-slider-multitool'
import CustomStaffGallery from 'components/custom/custom-staff-gallery/custom-staff-gallery'
import BlockRepeater from 'components/block/block-image-repeater/block-image-repeater'
import Parallax from 'vue-parallaxy'

export default {
  name: 'about-us',
  computed: {
    props () {
      return this.$store.state.pages.aboutus
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    Hero,
    HeadBar,
    HeadMainBar,
    TextBox,
    Slider,
    CustomSlider,
    SliderStaff,
    CustomStaffGallery,
    BlockRepeater,
    Parallax
  }
}
</script>



// WEBPACK FOOTER //
// about-us.vue?72a5c63a